import { useFormik } from 'formik';
import React, { useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as Yup from 'yup';
import InfoBox from '../../../components/InfoBox';
import { resetPassword } from '../_redux/authCrud';
import * as auth from '../_redux/authRedux';

const initialValues = {
  password: '',
};
const initialDialogData = {
  open: false,
  icon1: 'success',
  title: 'Unknown',
  text: 'hello',
  buttonOk: true,
  buttonYes: false,
  buttonNo: false,
};

function ResetPassword(props) {
  // const history = useHistory();
  console.log('ResetPassword', props);
  let { token } = props;
  const { intl } = props;
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [showInfoBox, setShowInfoBox] = useState(false);
  const [infoData, setInfoData] = useState(initialDialogData);
  const passwordLabel = intl.formatMessage({ id: 'AUTH.LOGIN.PASSWORD' });
  const passwordConfirmLabel = intl.formatMessage({ id: 'AUTH.RESET.CONFIRM' });

  const passwordFormat = intl.formatMessage({
    id: 'AUTH.VALIDATION.PASSWORD.FORMAT',
  });
  const passwordConfirm = intl.formatMessage({
    id: 'AUTH.VALIDATION.PASSWORD.CONFIRM',
  });
  const successInfo = intl.formatMessage({ id: 'AUTH.RESET.SUCCESS' });

  const passMinLengthError =
    intl
      .formatMessage({ id: 'AUTH.VALIDATION.MIN_LENGTH_FIELD' })
      .replace('{value}', '6') +
    ' ' +
    passwordFormat;
  const passMaxLengthError =
    intl
      .formatMessage({ id: 'AUTH.VALIDATION.MAX_LENGTH_FIELD' })
      .replace('{value}', '20') +
    ' ' +
    passwordFormat;

  const ResetPasswordSchema = Yup.object().shape({
    password: Yup.string()
      .min(6, passMinLengthError)
      .max(20, passMaxLengthError)
      .required(
        intl.formatMessage({
          id: 'AUTH.VALIDATION.REQUIRED_FIELD',
        })
      ),
    changepassword: Yup.string()
      .required(
        intl.formatMessage({
          id: 'AUTH.VALIDATION.REQUIRED_FIELD',
        })
      )
      .when('password', {
        is: (val) => (val && val.length > 0 ? true : false),
        then: Yup.string().oneOf([Yup.ref('password')], passwordConfirm),
      }),
  });

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return 'is-invalid';
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return 'is-valid';
    }

    return '';
  };

  const showMsg = (params) => {
    const { icon, text, onConfirm } = params;
    const titleConfirm = intl.formatMessage({ id: 'AUTH.RESET.TITLE' });
    /* MessageBox({ icon, title: titleConfirm, text, labelOk, onConfirm }); */
    setInfoData({
      ...infoData,
      openInfoDialog: true,
      setOpenInfoDialog: setShowInfoBox,
      icon,
      title: titleConfirm,
      text,
      onConfirm,
    });
    setShowInfoBox(true);
  };

  // const onConfirm = () => {
  //   history.push('/auth/login', { msg: successInfo });
  // };
  const savePassword = (values, { setStatus, setSubmitting }) => {
    setSubmitting(true);
    enableLoading();
    resetPassword(token, values.password)
      .then((response) => {
        console.log('ResetPassword response', response.data);
        switch (response.data.type) {
          case 'SUCCESS':
          case 'SUCCESS_WITH_WARNING':
          case 'SUCCESS_WITH_INFO':
            console.log(response.data.type);
            //props.resetPassword();
            setSuccess(true);
            disableLoading();
            setSubmitting(false);
            setStatus({ type: 'success', msg: successInfo });
            showMsg({
              icon: 'success',
              text: 'Нууц үг амжилттай шинэчлэгдлээ.',
            });

            break;
          default:
            console.log(response.data.msg.desc);
            disableLoading();
            setSubmitting(false);
            setStatus({ type: 'error', msg: response.data.msg.desc });
          //showMsg({icon: 'success', text: response.data.msg.desc})
        }
      })
      .catch((error) => {
        disableLoading();
        setSubmitting(false);
        setStatus({ type: 'error', msg: error });
      });
  };

  const formik = useFormik({
    initialValues,
    validationSchema: ResetPasswordSchema,
    onSubmit: savePassword,
  });
  return (
    <div className='login-form login-signin' style={{ display: 'block' }}>
      <div className='text-center mb-10 mb-lg-20'>
        <h3 className='font-size-h1'>
          <FormattedMessage id='AUTH.RESET.TITLE' />
        </h3>

        <p className='text-muted font-weight-bold'>
          {!success ? <FormattedMessage id='AUTH.RESET.DESC' /> : ''}
        </p>
      </div>

      <form
        id='kt_login_signin_form'
        className='form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp'
        onSubmit={formik.handleSubmit}
      >
        {formik.status && formik.status.type === 'error' && (
          <div className='mb-10 alert alert-custom alert-light-danger alert-dismissible'>
            <div className='alert-text font-weight-bold'>
              {formik.status.msg}
            </div>
          </div>
        )}

        {formik.status && formik.status.type === 'success' && (
          <div className='mb-10 alert alert-custom alert-light-success alert-dismissible'>
            <div className='alert-text font-weight-bold'>
              {formik.status.msg}
            </div>
          </div>
        )}
        <div className='form-group fv-plugins-icon-container'>
          <input
            placeholder={passwordLabel}
            type='password'
            className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
              'password'
            )}`}
            name='password'
            {...formik.getFieldProps('password')}
            disabled={success}
          />
          {formik.touched.password && formik.errors.password ? (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>{formik.errors.password}</div>
            </div>
          ) : null}
        </div>
        <div className='form-group fv-plugins-icon-container'>
          <input
            placeholder={passwordConfirmLabel}
            type='password'
            className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
              'changepassword'
            )}`}
            name='changepassword'
            {...formik.getFieldProps('changepassword')}
            disabled={success}
          />
          {formik.touched.changepassword && formik.errors.changepassword ? (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                {formik.errors.changepassword}
              </div>
            </div>
          ) : null}
        </div>
        {showInfoBox && <InfoBox data={infoData} />}
        {success ? (
          <div className='form-group d-flex flex-wrap flex-center'>
            <Link to='/auth/login'>
              <button
                type='submit'
                className='btn btn-info font-weight-bold px-9 py-4 my-3 mx-4'
              >
                <FormattedMessage id='AUTH.RESET.LOGINLINK' />
              </button>
            </Link>
          </div>
        ) : (
          <div className='form-group d-flex flex-wrap flex-center'>
            <button
              type='submit'
              disabled={formik.isSubmitting || !formik.isValid}
              className='btn btn-info font-weight-bold px-9 py-4 my-3 mx-4'
            >
              <FormattedMessage id='AUTH.GENERAL.SAVE_BUTTON' />
              {loading && <span className='ml-3 spinner spinner-white'></span>}
            </button>
            <Link to='/auth/login'>
              <button
                type='button'
                className='btn btn-light-info font-weight-bold px-9 py-4 my-3 mx-4'
              >
                <FormattedMessage id='AUTH.GENERAL.CANCEL' />
              </button>
            </Link>
          </div>
        )}
      </form>
    </div>
  );
}

export default injectIntl(connect(null, auth.actions)(ResetPassword));
